import { render, staticRenderFns } from "./adsorbate-species-detail.vue?vue&type=template&id=da9f094c&"
import script from "./adsorbate-species-detail.vue?vue&type=script&lang=js&"
export * from "./adsorbate-species-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports